module.exports = __webpack_public_path__ + "static/media/hp_match.c1ce6640.svg";